import { createResource } from 'react-resource-router';

import { type ResourceDependencies } from '../../../common/types';
import { getMyTeamsEndpoint } from '../../endpoints/my-teams';

export const createMyTeamsResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => Promise<boolean>,
	depends?: string[],
) =>
	createResource({
		type: 'myTeamsResource',
		getKey: () => 'myTeamsResource',
		getData: async ({ dependencies }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? await checkConsolidationOnRouteDependency(dependencies as ResourceDependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			return getMyTeamsEndpoint();
		},
		isBrowserOnly: true,
		depends,
	});
